import { api } from "./axios";
import { ComplaintStatus, Priority } from "@/components/shared/StatusBadge";

interface Envelope<T> {
  success: true;
  data: T;
}

export interface DashboardSummary {
  totalCustomers: number;
  totalComplaints: number;
  pending: number;
  inProgress: number;
  completed: number;
  overdue: number;
  todaysJobs: number;
}

export interface TrendPoint {
  date: string;
  created: number;
  completed: number;
}

export interface EmployeePerformanceRow {
  id: string;
  fullName: string;
  status: "ACTIVE" | "INACTIVE" | "ON_LEAVE";
  performanceScore: number;
  activeJobs: number;
  completedJobs: number;
}

export interface NotificationComplaint {
  id: string;
  complaintNumber: string;
  productName: string;
  status: ComplaintStatus;
  priority: Priority;
  expectedCompletionDate: string | null;
  createdAt: string;
  customer: { fullName: string };
}

export interface NotificationLists {
  pending: NotificationComplaint[];
  overdue: NotificationComplaint[];
  today: NotificationComplaint[];
}

export const dashboardApi = {
  async getSummary(): Promise<DashboardSummary> {
    const res = await api.get<Envelope<DashboardSummary>>("/dashboard/summary");
    return res.data.data;
  },

  async getComplaintTrend(range = "30d"): Promise<TrendPoint[]> {
    const res = await api.get<Envelope<TrendPoint[]>>("/dashboard/complaint-trend", {
      params: { range },
    });
    return res.data.data;
  },

  async getEmployeePerformance(): Promise<EmployeePerformanceRow[]> {
    const res = await api.get<Envelope<EmployeePerformanceRow[]>>("/dashboard/employee-performance");
    return res.data.data;
  },

  async getNotifications(): Promise<NotificationLists> {
    const res = await api.get<Envelope<NotificationLists>>("/dashboard/notifications");
    return res.data.data;
  },
};
